export default "__VITE_ASSET__CsiMNeAy__"